import { render, staticRenderFns } from "./StripeForm.vue?vue&type=template&id=1b65e64c&scoped=true&"
import script from "./StripeForm.vue?vue&type=script&lang=js&"
export * from "./StripeForm.vue?vue&type=script&lang=js&"
import style0 from "./StripeForm.vue?vue&type=style&index=0&id=1b65e64c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65e64c",
  null
  
)

export default component.exports